import React, {useRef, useState} from 'react';
import AnimatedPage from '../../components/AnimatedPage';
import Img from '../../assets/images/QR thanhtoan.png';
import QRFrame from '../../assets/images/QR_Frame.png';
import QRThumb1 from '../../assets/images/qr-thumb-1.png';
import QRThumb2 from '../../assets/images/qr-thumb-2.png';
import QRVNVideo from '../../assets/videos/QR_VN.mp4';
import QRSubChineseVideo from '../../assets/videos/QR_Sub_Chinese.mp4';
import {motion} from 'framer-motion';
import styled from 'styled-components';
import {BackButton} from '../../components/BackButton';
import PauseIcon from '../../assets/images/pause-button.png';
import PlayIconImage from '../../assets/images/play-button.png';

const QRPay = () => {
  const [isPlayingVideo1, setIsPlayingVideo1] = useState(false);
  const [showPlayIcon1, setShowPlayIcon1] = useState(false);
  const videoRef1 = useRef(null);
  const [isPlayingVideo2, setIsPlayingVideo2] = useState(false);
  const [showPlayIcon2, setShowPlayIcon2] = useState(false);
  const videoRef2 = useRef(null);

  const handleVideo1Click = () => {
    if (isPlayingVideo1) {
      videoRef1.current.pause();
      setIsPlayingVideo1(false);
    } else {
      if (isPlayingVideo2) {
        videoRef2.current.pause();
        setIsPlayingVideo2(false);
        setShowPlayIcon2(false);
      }
      videoRef1.current.play();
      setIsPlayingVideo1(true);
    }
    setShowPlayIcon1(true);
    setTimeout(() => setShowPlayIcon1(false), 1000);
  };

  const handleVideo2Click = () => {
    if (isPlayingVideo2) {
      videoRef2.current.pause();
      setIsPlayingVideo2(false);
    } else {
      if (isPlayingVideo1) {
        videoRef1.current.pause();
        setIsPlayingVideo1(false);
        setShowPlayIcon1(false);
      }
      videoRef2.current.play();
      setIsPlayingVideo2(true);
    }
    setShowPlayIcon2(true);
    setTimeout(() => setShowPlayIcon2(false), 1000);
  };

  return (
    <AnimatedPage animationType="fade">
      <BackButton />
      <Container>
        <ImageSection>
        <motion.img
          src={Img}
          alt="QR thanh toán xuyên biên giới"
          initial={{opacity: 0, scale: 0.8}}
          animate={{opacity: 1, scale: 1}}
          transition={{delay: 0.1, duration: 0.5, ease: 'easeOut'}}
          style={{width: '100%', height: '100%', objectFit: 'contain', display: 'block'}}
        />
        </ImageSection>
        <VideoSection>
          <VideoFrame
            as={motion.div}
            initial={{opacity: 0, scale: 0.8}}
            animate={{opacity: 1, scale: 1}}
            transition={{delay: 0.2, duration: 0.5, ease: 'easeOut'}}
            onClick={handleVideo1Click}
          >
            <FrameImage src={QRFrame} alt="" />
            <StyledVideo ref={videoRef1} src={QRVNVideo} muted={false} poster={QRThumb1} />
            {showPlayIcon1 && (
              <PlayIcon
                as={motion.div}
                initial={{opacity: 0, scale: 0.5}}
                animate={{opacity: 1, scale: 1}}
                exit={{opacity: 0, scale: 0.5}}
                transition={{duration: 0.2}}
              >
                {isPlayingVideo1
                  ? <img src={PauseIcon} alt="Pause" width="60px" height="60px" />
                  : <img src={PlayIconImage} alt="Play" width="60px" height="60px" />}
              </PlayIcon>
            )}
          </VideoFrame>
          <VideoFrame
            as={motion.div}
            initial={{opacity: 0, scale: 0.8}}
            animate={{opacity: 1, scale: 1}}
            transition={{delay: 0.3, duration: 0.5, ease: 'easeOut'}}
            onClick={handleVideo2Click}
          >
            <FrameImage src={QRFrame} alt="" />
            <StyledVideo ref={videoRef2} src={QRSubChineseVideo} muted={false} poster={QRThumb2} />
            {showPlayIcon2 && (
              <PlayIcon
                as={motion.div}
                initial={{opacity: 0, scale: 0.5}}
                animate={{opacity: 1, scale: 1}}
                exit={{opacity: 0, scale: 0.5}}
                transition={{duration: 0.2}}
              >
                {isPlayingVideo2
                  ? <img src={PauseIcon} alt="Pause" width="60px" height="60px" />
                  : <img src={PlayIconImage} alt="Play" width="60px" height="60px" />}
              </PlayIcon>
            )}
          </VideoFrame>
        </VideoSection>
      </Container>
    </AnimatedPage>
  );
};

const Container = styled.div`
  --page-padding-x: calc(110 / 4096 * 100vw);
  --page-padding-y: calc(110 / 2160 * 100vh);
  --panel-gap: calc(72 / 4096 * 100vw);
  --panel-width-by-screen: calc((100vw - (2 * var(--page-padding-x)) - (2 * var(--panel-gap))) / 3);
  --panel-width-by-height: calc((100vh - (2 * var(--page-padding-y))) * 3474 / 2969);
  --panel-width: min(var(--panel-width-by-screen), var(--panel-width-by-height));
  box-sizing: border-box;
  width: 100%;
  height: 100%;
  padding: var(--page-padding-y) var(--page-padding-x);
  display: flex;
  align-items: center;
  justify-content: center;
  gap: var(--panel-gap);
  overflow: hidden;
`;

const ImageSection = styled.div`
  width: var(--panel-width);
  aspect-ratio: 3474 / 2969;
  flex: 0 0 auto;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const VideoSection = styled.div`
  width: calc((2 * var(--panel-width)) + var(--panel-gap));
  flex: 0 0 auto;
  display: flex;
  align-items: center;
  gap: var(--panel-gap);
`;

const VideoFrame = styled.div`
  position: relative;
  width: var(--panel-width);
  aspect-ratio: 3474 / 2969;
  flex: 0 0 auto;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const FrameImage = styled.img`
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  object-fit: fill;
  pointer-events: none;
  z-index: 1;
`;

const StyledVideo = styled.video`
  width: 97%;
  height: auto;
  object-fit: contain;
  border-radius: 10px;
  background-color: #05520000;
  z-index: 2;
`;

const PlayIcon = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  padding: 20px;
  width: 60px;
  height: 60px;
  border-radius: 50%;
  pointer-events: none;
  animation: fadeInOut 1s ease-in-out;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 3;

  @keyframes fadeInOut {
    0% { opacity: 0; }
    50% { opacity: 1; }
    100% { opacity: 0; }
  }
`;

export default QRPay;
